import $ from 'jquery';

export default function initM74() {
  $(function () {
    if ($('.module-m74').length > 0) {
      $('.module-m74').each(function () {
        let $module = $(this);
        $module.on('click', '.module-m74-card-content a.bio-popup, .whole-tile-cta.bio-popup', function (e) {
          e.preventDefault();
          let $button = $(this);
          let $content = $(this).closest('.module-m74-card').find('.module-m74-card-content');
          let $bio = $content.find('.module-m74-card-content-bio');
          if ($(window).width() < 768) {
            if ($bio.is(':visible')) {
              $bio.slideUp();
            } else {
              $bio.slideDown();
            }
          } else {
            let $card = $(this).closest('.module-m74-card');
            // let $container = $module.find('.module-m74-card-content-bio-container');
            // let al = $card.find('a').parent().position().left;
            if ($card.hasClass('showing')) {
              // console.log("card has showing: ", $card);
              $card.removeClass('showing');
              $module.find('.bio-popup.active').removeClass('active');
              $('.module-m74-card-content-bio-container').remove();
              $(document).off('click', m74OnClick);
            } else {
              $module.find('.bio-popup.active').removeClass('active');
              $button.addClass('active');
              $module.find('.module-m74-card.showing').removeClass('showing');
              // console.log("card doesn't have showing: ", $card);
              $('.module-m74-card-content-bio-container').remove();
              $card.addClass('showing');
              let $container = $('<div />').appendTo('body');
              $container.addClass('module-m74-card-content-bio-container');
              let $containerContent = $('<div />').addClass('module-m74-card-content-bio-container-content');
              let top = $card.offset().top + $card.height() + 21; // + $container.outerHeight();
              let left = $module.find('> .container').offset().left;

              $container.css({
                top: top + 'px',
                // left: left + 'px',
                width: $module.find('> .container').width() + 'px',
              });
              $container.toggleClass('show');

              let $arrow = $('<div />').addClass('module-m74-card-content-bio-container-arrow');

              let arrowLeft = $card.find('a').parent().offset().left + $card.find('a').width() / 2;
              $arrow.css({
                left: arrowLeft - left + 'px',
              });
              let $close = $('<a />').attr('href', '#').addClass('close').appendTo($container);
              // console.log("Container offset: ", $container.offset());

              $container.append($arrow);
              $containerContent.html($bio.html()).appendTo($container);
              $container.on('click', 'a.close', function (e) {
                e.preventDefault();
                $('.module-m74-card-content-bio-container').remove();
                $button.removeClass('active');
                $module.find('.module-m74-card.showing').removeClass('showing');
                $(document).off('click', m74OnClick);
              });

              // Hide the popup when clicking anywhere outside of it
              function m74OnClick(e) {
                if (!$container.is(e.target) && $container.has(e.target).length === 0) {
                  $container.find('a').trigger('click');
                }
              }

              setTimeout(function () {
                $(document).on('click', m74OnClick);
              }, 250);
            }
          }
        });
      });
    }
  });
}
